// extracted by mini-css-extract-plugin
export default {"CVGraphContainer":"GeneralGraphPatient_CVGraphContainer__-kt5y"};